import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import PersonIcon from '@mui/icons-material/Person';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useIntl } from 'react-intl';

import { TimeHelper } from '../../../utils/timeHelper';
import { CalendarEventSourceEnum } from '../../../types/Appointment';

type Props = {
  source?: CalendarEventSourceEnum;
  createdAt: number;
  timezone: string;
};

export function BookingChannelBadge({ source, createdAt, timezone }: Props) {
  const intl = useIntl();

  const isOnline = source === CalendarEventSourceEnum.EXTERNAL_API;

  let channelLabel = intl.formatMessage({ id: 'appointment.bookingChannel.inPerson' });
  if (isOnline) {
    channelLabel = intl.formatMessage({ id: 'appointment.bookingChannel.online' });
  }

  let Icon = PersonIcon;
  if (isOnline) {
    Icon = LanguageIcon;
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      rowGap={0.5}
      columnGap={0.75}
      pt={2}
      data-testid="booking-channel-badge"
    >
      <Stack direction="row" spacing={0.5} alignItems="start" color="text.secondary" minWidth={0}>
        <AccessTimeIcon fontSize="small" />

        <Typography variant="body1" sx={{ overflowWrap: 'anywhere' }}>
          {`${intl.formatMessage({ id: 'appointment.bookedLabel' })}: `}
          <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
            {TimeHelper.toDayMonthYearTimeFormat(createdAt, timezone)}
          </Box>
        </Typography>
      </Stack>

      {/* <Stack direction="row" alignItems="start" spacing={0.5} color="text.secondary" minWidth={0}>
        <Icon color="inherit" fontSize="small" sx={{ flexShrink: 0 }} />

        <Typography variant="body1" sx={{ overflowWrap: 'anywhere' }}>
          {channelLabel}
        </Typography>
      </Stack> */}
    </Stack>
  );
}

BookingChannelBadge.defaultProps = {
  source: undefined,
};
